import {
  manualTransactionHistoryTableColumns,
  transactionHistoryTableColumns,
} from '../../../constants/tableColumns';
import { useTransactionContext } from '../../../contexts/TransactionProvider';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import TransactionTableToolbar from './TransactionTableToolbar';

const ShowAllTransactionHistory = () => {
  // integration of context hooks here
  const {
    isTransactionsLoading,
    isTransactionsFetching,
    transactionType,
    transactionHistory,
    manualTransactionHistory,
  } = useTransactionContext();

  console.log('TRANSACTION LIST: ', transactionHistory);

  // rendering show all transaction history section component here
  return (
    <section>
      {isTransactionsLoading ? (
        <AcademiaLoading />
      ) : (
        <>
          <PageHeader headerText='Transaction History' />

          <AcademiaTable
            data={
              transactionType === 'gateway'
                ? transactionHistory
                : manualTransactionHistory
            }
            columns={
              transactionType === 'gateway'
                ? transactionHistoryTableColumns
                : manualTransactionHistoryTableColumns
            }
            notFoundMessage='No transaction history found!'
            tableToolbarComponent={<TransactionTableToolbar />}
            isTableDataLoading={isTransactionsFetching}
          />
        </>
      )}
    </section>
  );
};

export default ShowAllTransactionHistory;
